export const MAvatarColors = {
  photoContainer: '#E5E5E8',
  username: '#000000',
  status: '#7F7F88',
};
